var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function t(e) {
  if (e.__esModule) return e;
  var t = Object.defineProperty({}, "__esModule", {
    value: !0
  });
  return Object.keys(e).forEach(function (r) {
    var n = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(t, r, n.get ? n : {
      enumerable: !0,
      get: function get() {
        return e[r];
      }
    });
  }), t;
}

function r(e) {
  var t = {
    exports: {}
  };
  return e(t, t.exports), t.exports;
}

let n = !1;
"process" in e && (n = /^v8\./.test(e.process.version));
var o = t(Object.freeze({
  __proto__: null,
  default: {}
})),
    i = r(function (t) {
  !function (e, r, n) {
    var i,
        c = 256,
        a = n.pow(c, 6),
        u = n.pow(2, 52),
        f = 2 * u,
        s = 255;

    function l(t, o, s) {
      var l = [],
          w = h(y((o = 1 == o ? {
        entropy: !0
      } : o || {}).entropy ? [t, g(r)] : null == t ? function () {
        try {
          var t;
          return i && (t = i.randomBytes) ? t = t(c) : (t = new Uint8Array(c), (e.crypto || e.msCrypto).getRandomValues(t)), g(t);
        } catch (t) {
          var n = e.navigator,
              o = n && n.plugins;
          return [+new Date(), e, o, e.screen, g(r)];
        }
      }() : t, 3), l),
          b = new d(l),
          v = function v() {
        for (var e = b.g(6), t = a, r = 0; e < u;) e = (e + r) * c, t *= c, r = b.g(1);

        for (; e >= f;) e /= 2, t /= 2, r >>>= 1;

        return (e + r) / t;
      };

      return v.int32 = function () {
        return 0 | b.g(4);
      }, v.quick = function () {
        return b.g(4) / 4294967296;
      }, v.double = v, h(g(b.S), r), (o.pass || s || function (e, t, r, o) {
        return o && (o.S && p(o, b), e.state = function () {
          return p(b, {});
        }), r ? (n.random = e, t) : e;
      })(v, w, "global" in o ? o.global : this == n, o.state);
    }

    function d(e) {
      var t,
          r = e.length,
          n = this,
          o = 0,
          i = n.i = n.j = 0,
          a = n.S = [];

      for (r || (e = [r++]); o < c;) a[o] = o++;

      for (o = 0; o < c; o++) a[o] = a[i = s & i + e[o % r] + (t = a[o])], a[i] = t;

      (n.g = function (e) {
        for (var t, r = 0, o = n.i, i = n.j, a = n.S; e--;) t = a[o = s & o + 1], r = r * c + a[s & (a[o] = a[i = s & i + t]) + (a[i] = t)];

        return n.i = o, n.j = i, r;
      })(c);
    }

    function p(e, t) {
      return t.i = e.i, t.j = e.j, t.S = e.S.slice(), t;
    }

    function y(e, t) {
      var r,
          n = [],
          o = typeof e;
      if (t && "object" == o) for (r in e) try {
        n.push(y(e[r], t - 1));
      } catch (e) {}
      return n.length ? n : "string" == o ? e : e + "\0";
    }

    function h(e, t) {
      for (var r, n = e + "", o = 0; o < n.length;) t[s & o] = s & (r ^= 19 * t[s & o]) + n.charCodeAt(o++);

      return g(t);
    }

    function g(e) {
      return String.fromCharCode.apply(0, e);
    }

    if (h(n.random(), r), t.exports) {
      t.exports = l;

      try {
        i = o;
      } catch (e) {}
    } else n.seedrandom = l;
  }("undefined" != typeof self ? self : e, [], Math);
});

var c = function c(e) {
  const t = i;
  let r, n;

  try {
    r = (o = "require", c = "react-native", e[o](c)).NativeModules.SyncRandomBytes, r && (n = r.seed);
  } catch (e) {}

  var o, c;
  !n && e && "Expo" in e && (n = function (e) {
    const t = e.reduce(function (e, t) {
      return e + 2 * t.length;
    }, 0),
          r = new ArrayBuffer(t),
          n = new Uint16Array(r);
    let o = 0;
    return e.forEach(function (e) {
      for (var t = 0, r = e.length; t < r; t++) n[o + t] = e.charCodeAt(t);

      o += e.length;
    }), n;
  }([e.Expo.Constants.installationId, e.Expo.Constants.sessionId, "performance" in e ? e.performance.now().toString(32) : new Date().toISOString(), Math.random().toString(32)]));
  let a = t(n),
      u = !1;

  function f(e) {
    if (e.length > 65536) throw new Error("QuotaExceeded");

    for (let t = (.25 * e.length + 1 | 0) - 1, r = 0; t >= 0; t--) {
      const t = a.int32();
      e[r++] = 255 & t, e[r++] = t >> 8 & 255, e[r++] = t >> 16 & 255, e[r++] = t >> 24 & 255;
    }

    return e;
  }

  return !n && r && (u = !0, r.randomBytes().then(e => {
    u = !1, a = t(e);
  }).catch(function (e) {
    u = !1, console.log("WARNING: can not collect seed data: ".concat(e.message));
  })), function (e) {
    if (u && (u = !1, console.log("WARNING: random data is requested before the seed is done")), null == e) throw new Error("invalid type");
    if (e instanceof Uint8Array) return f(e);
    if (e instanceof Uint32Array) return function (e) {
      const t = e.length;
      if (t > 16384) throw new Error("QuotaExceeded");

      for (let r = t - 1; r >= 0; r--) e[r] = a.int32();

      return e;
    }(e);
    if (e instanceof Uint16Array) return function (e) {
      if (e.length > 32767) throw new Error("QuotaExceeded");

      for (let t = (.5 * e.length + 1 | 0) - 1, r = 0; t >= 0; t--) {
        const t = a.int32();
        e[r++] = 65535 & t, e[r++] = t >> 16 & 65535;
      }

      return e;
    }(e);
    if (e instanceof Int32Array) return function (e) {
      const t = e.length;
      if (t > 16384) throw new Error("QuotaExceeded");

      for (let r = t - 1; r >= 0; r--) e[r] = a.int32() - 2147483648;

      return e;
    }(e);
    if (e instanceof Int16Array) return function (e) {
      if (e.length > 32767) throw new Error("QuotaExceeded");

      for (let t = (.5 * e.length + 1 | 0) - 1, r = 0; t >= 0; t--) {
        const t = a.int32();
        e[r++] = (65535 & t) - 32768, e[r++] = (t >> 16 & 65535) - 32768;
      }

      return e;
    }(e);
    if (e instanceof Int8Array) return function (e) {
      if (e.length > 65536) throw new Error("QuotaExceeded");

      for (let t = (.25 * e.length + 1 | 0) - 1, r = 0; t >= 0; t--) {
        const t = a.int32();
        e[r++] = (255 & t) - 128, e[r++] = (t >> 8 & 255) - 128, e[r++] = (t >> 16 & 255) - 128, e[r++] = (t >> 24 & 255) - 128;
      }

      return e;
    }(e);
    if (e instanceof Uint8ClampedArray) return f(e);
    throw new Error("invalid type");
  };
},
    a = r(function (e) {
  e.exports = function (e) {
    if (e && e.crypto && e.crypto.getRandomValues) return e.crypto.getRandomValues.bind(e.crypto);

    try {
      return function (e) {
        const t = (r = "crypto", e.require(r));
        var r;

        function o(e, t) {
          const r = e.length;

          for (let n = 0, o = 0; n < r; n++) e[n] = t[o++] << 24 | t[o++] << 16 | t[o++] << 8 | t[o++];

          return e;
        }

        function i(e, t) {
          const r = e.length;

          for (let n = 0, o = 0; n < r; n++) e[n] = (t[o++] << 24 | t[o++] << 16 | t[o++] << 8 | t[o++]) - 2147483648;

          return e;
        }

        function c(e, t) {
          const r = e.length;

          for (let n = 0, o = 0; n < r; n++) e[n] = t[o++] << 8 | t[o++];

          return e;
        }

        function a(e, t) {
          const r = e.length;

          for (let n = 0, o = 0; n < r; n++) e[n] = (t[o++] << 8 | t[o++]) - 32768;

          return e;
        }

        function u(e, t) {
          const r = e.length;

          for (let n = 0; n < r; n++) e[n] = t[n];

          return e;
        }

        function f(e, t) {
          const r = e.length;

          for (let n = 0; n < r; n++) e[n] = t[n] - 128;

          return e;
        }

        return n ? function (e) {
          if (e instanceof Uint8Array) return t.randomFillSync(e);
          const r = t.randomBytes(e.byteLength);
          if (e instanceof Uint32Array) return o(e, r);
          if (e instanceof Uint16Array) return c(e, r);
          if (e instanceof Int32Array) return i(e, r);
          if (e instanceof Int16Array) return a(e, r);
          if (e instanceof Int8Array) return f(e, r);
          if (e instanceof Uint8ClampedArray) return u(e, r);
          throw new Error("invalid type");
        } : t.randomFillSync || function (e) {
          const r = t.randomBytes(e.byteLength);
          if (e instanceof Uint8Array) return u(e, r);
          if (e instanceof Uint32Array) return o(e, r);
          if (e instanceof Uint16Array) return c(e, r);
          if (e instanceof Int32Array) return i(e, r);
          if (e instanceof Int16Array) return a(e, r);
          if (e instanceof Int8Array) return f(e, r);
          if (e instanceof Uint8ClampedArray) return u(e, r);
          throw new Error("invalid type");
        };
      }(e);
    } catch (t) {
      return c(e);
    }
  }("object" == typeof window ? window : e);
});

var u = function u(e) {
  if (e.length >= 255) throw new TypeError("Alphabet too long");

  for (var t = new Uint8Array(256), r = 0; r < t.length; r++) t[r] = 255;

  for (var n = 0; n < e.length; n++) {
    var o = e.charAt(n),
        i = o.charCodeAt(0);
    if (255 !== t[i]) throw new TypeError(o + " is ambiguous");
    t[i] = n;
  }

  var c = e.length,
      a = e.charAt(0),
      u = Math.log(c) / Math.log(256),
      f = Math.log(256) / Math.log(c);

  function s(e) {
    if ("string" != typeof e) throw new TypeError("Expected String");
    if (0 === e.length) return new Uint8Array();
    var r = 0;

    if (" " !== e[r]) {
      for (var n = 0, o = 0; e[r] === a;) n++, r++;

      for (var i = (e.length - r) * u + 1 >>> 0, f = new Uint8Array(i); e[r];) {
        var s = t[e.charCodeAt(r)];
        if (255 === s) return;

        for (var l = 0, d = i - 1; (0 !== s || l < o) && -1 !== d; d--, l++) s += c * f[d] >>> 0, f[d] = s % 256 >>> 0, s = s / 256 >>> 0;

        if (0 !== s) throw new Error("Non-zero carry");
        o = l, r++;
      }

      if (" " !== e[r]) {
        for (var p = i - o; p !== i && 0 === f[p];) p++;

        for (var y = new Uint8Array(n + (i - p)), h = n; p !== i;) y[h++] = f[p++];

        return y;
      }
    }
  }

  return {
    encode: function encode(t) {
      if (t instanceof Uint8Array || (ArrayBuffer.isView(t) ? t = new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : Array.isArray(t) && (t = Uint8Array.from(t))), !(t instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
      if (0 === t.length) return "";

      for (var r = 0, n = 0, o = 0, i = t.length; o !== i && 0 === t[o];) o++, r++;

      for (var u = (i - o) * f + 1 >>> 0, s = new Uint8Array(u); o !== i;) {
        for (var l = t[o], d = 0, p = u - 1; (0 !== l || d < n) && -1 !== p; p--, d++) l += 256 * s[p] >>> 0, s[p] = l % c >>> 0, l = l / c >>> 0;

        if (0 !== l) throw new Error("Non-zero carry");
        n = d, o++;
      }

      for (var y = u - n; y !== u && 0 === s[y];) y++;

      for (var h = a.repeat(r); y < u; ++y) h += e.charAt(s[y]);

      return h;
    },
    decodeUnsafe: s,
    decode: function decode(e) {
      var t = s(e);
      if (t) return t;
      throw new Error("Non-base" + c + " character");
    }
  };
},
    f = function f(e) {
  return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
},
    s = r(function (e) {
  "function" == typeof Object.create ? e.exports = function (e, t) {
    e.super_ = t, e.prototype = Object.create(t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    });
  } : e.exports = function (e, t) {
    e.super_ = t;

    var r = function r() {};

    r.prototype = t.prototype, e.prototype = new r(), e.prototype.constructor = e;
  };
}),
    l = r(function (e, t) {
  var r = Object.getOwnPropertyDescriptors || function (e) {
    for (var t = Object.keys(e), r = {}, n = 0; n < t.length; n++) r[t[n]] = Object.getOwnPropertyDescriptor(e, t[n]);

    return r;
  },
      n = /%[sdj%]/g;

  t.format = function (e) {
    if (!b(e)) {
      for (var t = [], r = 0; r < arguments.length; r++) t.push(c(arguments[r]));

      return t.join(" ");
    }

    r = 1;

    for (var o = arguments, i = o.length, a = String(e).replace(n, function (e) {
      if ("%%" === e) return "%";
      if (r >= i) return e;

      switch (e) {
        case "%s":
          return String(o[r++]);

        case "%d":
          return Number(o[r++]);

        case "%j":
          try {
            return JSON.stringify(o[r++]);
          } catch (e) {
            return "[Circular]";
          }

        default:
          return e;
      }
    }), u = o[r]; r < i; u = o[++r]) g(u) || !E(u) ? a += " " + u : a += " " + c(u);

    return a;
  }, t.deprecate = function (e, r) {
    if ("undefined" != typeof process && !0 === process.noDeprecation) return e;
    if ("undefined" == typeof process) return function () {
      return t.deprecate(e, r).apply(this, arguments);
    };
    var n = !1;
    return function () {
      if (!n) {
        if (process.throwDeprecation) throw new Error(r);
        process.traceDeprecation ? console.trace(r) : console.error(r), n = !0;
      }

      return e.apply(this, arguments);
    };
  };
  var o,
      i = {};

  function c(e, r) {
    var n = {
      seen: [],
      stylize: u
    };
    return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), h(r) ? n.showHidden = r : r && t._extend(n, r), v(n.showHidden) && (n.showHidden = !1), v(n.depth) && (n.depth = 2), v(n.colors) && (n.colors = !1), v(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = a), l(n, e, n.depth);
  }

  function a(e, t) {
    var r = c.styles[t];
    return r ? "[" + c.colors[r][0] + "m" + e + "[" + c.colors[r][1] + "m" : e;
  }

  function u(e, t) {
    return e;
  }

  function l(e, r, n) {
    if (e.customInspect && r && j(r.inspect) && r.inspect !== t.inspect && (!r.constructor || r.constructor.prototype !== r)) {
      var o = r.inspect(n, e);
      return b(o) || (o = l(e, o, n)), o;
    }

    var i = function (e, t) {
      if (v(t)) return e.stylize("undefined", "undefined");

      if (b(t)) {
        var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return e.stylize(r, "string");
      }

      if (w(t)) return e.stylize("" + t, "number");
      if (h(t)) return e.stylize("" + t, "boolean");
      if (g(t)) return e.stylize("null", "null");
    }(e, r);

    if (i) return i;

    var c = Object.keys(r),
        a = function (e) {
      var t = {};
      return e.forEach(function (e, r) {
        t[e] = !0;
      }), t;
    }(c);

    if (e.showHidden && (c = Object.getOwnPropertyNames(r)), x(r) && (c.indexOf("message") >= 0 || c.indexOf("description") >= 0)) return d(r);

    if (0 === c.length) {
      if (j(r)) {
        var u = r.name ? ": " + r.name : "";
        return e.stylize("[Function" + u + "]", "special");
      }

      if (m(r)) return e.stylize(RegExp.prototype.toString.call(r), "regexp");
      if (A(r)) return e.stylize(Date.prototype.toString.call(r), "date");
      if (x(r)) return d(r);
    }

    var f,
        s = "",
        E = !1,
        O = ["{", "}"];
    (y(r) && (E = !0, O = ["[", "]"]), j(r)) && (s = " [Function" + (r.name ? ": " + r.name : "") + "]");
    return m(r) && (s = " " + RegExp.prototype.toString.call(r)), A(r) && (s = " " + Date.prototype.toUTCString.call(r)), x(r) && (s = " " + d(r)), 0 !== c.length || E && 0 != r.length ? n < 0 ? m(r) ? e.stylize(RegExp.prototype.toString.call(r), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(r), f = E ? function (e, t, r, n, o) {
      for (var i = [], c = 0, a = t.length; c < a; ++c) D(t, String(c)) ? i.push(p(e, t, r, n, String(c), !0)) : i.push("");

      return o.forEach(function (o) {
        o.match(/^\d+$/) || i.push(p(e, t, r, n, o, !0));
      }), i;
    }(e, r, n, a, c) : c.map(function (t) {
      return p(e, r, n, a, t, E);
    }), e.seen.pop(), function (e, t, r) {
      if (e.reduce(function (e, t) {
        return t.indexOf("\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
      }, 0) > 60) return r[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + r[1];
      return r[0] + t + " " + e.join(", ") + " " + r[1];
    }(f, s, O)) : O[0] + s + O[1];
  }

  function d(e) {
    return "[" + Error.prototype.toString.call(e) + "]";
  }

  function p(e, t, r, n, o, i) {
    var c, a, u;

    if ((u = Object.getOwnPropertyDescriptor(t, o) || {
      value: t[o]
    }).get ? a = u.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : u.set && (a = e.stylize("[Setter]", "special")), D(n, o) || (c = "[" + o + "]"), a || (e.seen.indexOf(u.value) < 0 ? (a = g(r) ? l(e, u.value, null) : l(e, u.value, r - 1)).indexOf("\n") > -1 && (a = i ? a.split("\n").map(function (e) {
      return "  " + e;
    }).join("\n").substr(2) : "\n" + a.split("\n").map(function (e) {
      return "   " + e;
    }).join("\n")) : a = e.stylize("[Circular]", "special")), v(c)) {
      if (i && o.match(/^\d+$/)) return a;
      (c = JSON.stringify("" + o)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (c = c.substr(1, c.length - 2), c = e.stylize(c, "name")) : (c = c.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), c = e.stylize(c, "string"));
    }

    return c + ": " + a;
  }

  function y(e) {
    return Array.isArray(e);
  }

  function h(e) {
    return "boolean" == typeof e;
  }

  function g(e) {
    return null === e;
  }

  function w(e) {
    return "number" == typeof e;
  }

  function b(e) {
    return "string" == typeof e;
  }

  function v(e) {
    return void 0 === e;
  }

  function m(e) {
    return E(e) && "[object RegExp]" === O(e);
  }

  function E(e) {
    return "object" == typeof e && null !== e;
  }

  function A(e) {
    return E(e) && "[object Date]" === O(e);
  }

  function x(e) {
    return E(e) && ("[object Error]" === O(e) || e instanceof Error);
  }

  function j(e) {
    return "function" == typeof e;
  }

  function O(e) {
    return Object.prototype.toString.call(e);
  }

  function S(e) {
    return e < 10 ? "0" + e.toString(10) : e.toString(10);
  }

  t.debuglog = function (e) {
    if (v(o) && (o = process.env.NODE_DEBUG || ""), e = e.toUpperCase(), !i[e]) if (new RegExp("\\b" + e + "\\b", "i").test(o)) {
      var r = process.pid;

      i[e] = function () {
        var n = t.format.apply(t, arguments);
        console.error("%s %d: %s", e, r, n);
      };
    } else i[e] = function () {};
    return i[e];
  }, t.inspect = c, c.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  }, c.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    regexp: "red"
  }, t.isArray = y, t.isBoolean = h, t.isNull = g, t.isNullOrUndefined = function (e) {
    return null == e;
  }, t.isNumber = w, t.isString = b, t.isSymbol = function (e) {
    return "symbol" == typeof e;
  }, t.isUndefined = v, t.isRegExp = m, t.isObject = E, t.isDate = A, t.isError = x, t.isFunction = j, t.isPrimitive = function (e) {
    return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
  }, t.isBuffer = f;
  var U = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  function T() {
    var e = new Date(),
        t = [S(e.getHours()), S(e.getMinutes()), S(e.getSeconds())].join(":");
    return [e.getDate(), U[e.getMonth()], t].join(" ");
  }

  function D(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }

  t.log = function () {
    console.log("%s - %s", T(), t.format.apply(t, arguments));
  }, t.inherits = s, t._extend = function (e, t) {
    if (!t || !E(t)) return e;

    for (var r = Object.keys(t), n = r.length; n--;) e[r[n]] = t[r[n]];

    return e;
  };
  var M = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;

  function z(e, t) {
    if (!e) {
      var r = new Error("Promise was rejected with a falsy value");
      r.reason = e, e = r;
    }

    return t(e);
  }

  t.promisify = function (e) {
    if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');

    if (M && e[M]) {
      var t;
      if ("function" != typeof (t = e[M])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      return Object.defineProperty(t, M, {
        value: t,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), t;
    }

    function t() {
      for (var t, r, n = new Promise(function (e, n) {
        t = e, r = n;
      }), o = [], i = 0; i < arguments.length; i++) o.push(arguments[i]);

      o.push(function (e, n) {
        e ? r(e) : t(n);
      });

      try {
        e.apply(this, o);
      } catch (e) {
        r(e);
      }

      return n;
    }

    return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), M && Object.defineProperty(t, M, {
      value: t,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), Object.defineProperties(t, r(e));
  }, t.promisify.custom = M, t.callbackify = function (e) {
    if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');

    function t() {
      for (var t = [], r = 0; r < arguments.length; r++) t.push(arguments[r]);

      var n = t.pop();
      if ("function" != typeof n) throw new TypeError("The last argument must be of type Function");

      var o = this,
          i = function i() {
        return n.apply(o, arguments);
      };

      e.apply(this, t).then(function (e) {
        process.nextTick(i, null, e);
      }, function (e) {
        process.nextTick(z, e, i);
      });
    }

    return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), Object.defineProperties(t, r(e)), t;
  };
}),
    d = {
  TextEncoder: "undefined" != typeof TextEncoder ? TextEncoder : l.TextEncoder,
  TextDecoder: "undefined" != typeof TextDecoder ? TextDecoder : l.TextDecoder
};

const p = d.TextEncoder,
      y = d.TextDecoder,
      h = new y(),
      g = new p();
var w = {
  decodeText: e => h.decode(e),
  encodeText: e => g.encode(e),
  concat: function concat(e, t) {
    const r = new Uint8Array(t);
    let n = 0;

    for (const t of e) r.set(t, n), n += t.length;

    return r;
  }
};
const b = w.encodeText;
var v = class {
  constructor(e, t, r, n) {
    this.name = e, this.code = t, this.codeBuf = b(this.code), this.alphabet = n, this.codec = r(n);
  }

  encode(e) {
    return this.codec.encode(e);
  }

  decode(e) {
    for (const t of e) if (this.alphabet && this.alphabet.indexOf(t) < 0) throw new Error("invalid character '".concat(t, "' in '").concat(e, "'"));

    return this.codec.decode(e);
  }

};
var m = {
  rfc4648: e => t => ({
    encode: r => ((e, t, r) => {
      const n = "=" === t[t.length - 1],
            o = (1 << r) - 1;
      let i = "",
          c = 0,
          a = 0;

      for (let n = 0; n < e.length; ++n) for (a = a << 8 | e[n], c += 8; c > r;) c -= r, i += t[o & a >> c];

      if (c && (i += t[o & a << r - c]), n) for (; i.length * r & 7;) i += "=";
      return i;
    })(r, t, e),
    decode: r => ((e, t, r) => {
      const n = {};

      for (let e = 0; e < t.length; ++e) n[t[e]] = e;

      let o = e.length;

      for (; "=" === e[o - 1];) --o;

      const i = new Uint8Array(o * r / 8 | 0);
      let c = 0,
          a = 0,
          u = 0;

      for (let t = 0; t < o; ++t) {
        const o = n[e[t]];
        if (void 0 === o) throw new SyntaxError("Invalid character " + e[t]);
        a = a << r | o, c += r, c >= 8 && (c -= 8, i[u++] = 255 & a >> c);
      }

      if (c >= r || 255 & a << 8 - c) throw new SyntaxError("Unexpected end of data");
      return i;
    })(r, t, e)
  })
};
const E = m.rfc4648,
      A = w.decodeText,
      x = w.encodeText,
      j = [["identity", "\0", () => ({
  encode: A,
  decode: x
}), ""], ["base2", "0", E(1), "01"], ["base8", "7", E(3), "01234567"], ["base10", "9", u, "0123456789"], ["base16", "f", E(4), "0123456789abcdef"], ["base16upper", "F", E(4), "0123456789ABCDEF"], ["base32hex", "v", E(5), "0123456789abcdefghijklmnopqrstuv"], ["base32hexupper", "V", E(5), "0123456789ABCDEFGHIJKLMNOPQRSTUV"], ["base32hexpad", "t", E(5), "0123456789abcdefghijklmnopqrstuv="], ["base32hexpadupper", "T", E(5), "0123456789ABCDEFGHIJKLMNOPQRSTUV="], ["base32", "b", E(5), "abcdefghijklmnopqrstuvwxyz234567"], ["base32upper", "B", E(5), "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"], ["base32pad", "c", E(5), "abcdefghijklmnopqrstuvwxyz234567="], ["base32padupper", "C", E(5), "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567="], ["base32z", "h", E(5), "ybndrfg8ejkmcpqxot1uwisza345h769"], ["base36", "k", u, "0123456789abcdefghijklmnopqrstuvwxyz"], ["base36upper", "K", u, "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"], ["base58btc", "z", u, "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"], ["base58flickr", "Z", u, "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"], ["base64", "m", E(6), "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"], ["base64pad", "M", E(6), "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="], ["base64url", "u", E(6), "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"], ["base64urlpad", "U", E(6), "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_="]],
      O = j.reduce((e, t) => (e[t[0]] = new v(t[0], t[1], t[2], t[3]), e), {}),
      S = j.reduce((e, t) => (e[t[1]] = O[t[0]], e), {});

var U = {
  names: O,
  codes: S
},
    T = r(function (e, t) {
  const r = w.encodeText,
        n = w.decodeText,
        o = w.concat;

  function i(e) {
    if (U.names[e]) return U.names[e];
    if (U.codes[e]) return U.codes[e];
    throw new Error("Unsupported encoding: ".concat(e));
  }

  (t = e.exports = function (e, t) {
    if (!t) throw new Error("requires an encoded Uint8Array");

    const _i = i(e),
          r = _i.name,
          c = _i.codeBuf;

    return function (e, t) {
      i(e).decode(n(t));
    }(r, t), o([c, t], c.length + t.length);
  }).encode = function (e, t) {
    const n = i(e),
          c = r(n.encode(t));
    return o([n.codeBuf, c], n.codeBuf.length + c.length);
  }, t.decode = function (e) {
    e instanceof Uint8Array && (e = n(e));
    const t = e[0];
    return ["f", "F", "v", "V", "t", "T", "b", "B", "c", "C", "h", "k", "K"].includes(t) && (e = e.toLowerCase()), i(e[0]).decode(e.substring(1));
  }, t.isEncoded = function (e) {
    if (e instanceof Uint8Array && (e = n(e)), "[object String]" !== Object.prototype.toString.call(e)) return !1;

    try {
      return i(e[0]).name;
    } catch (e) {
      return !1;
    }
  }, t.encoding = i, t.encodingFromData = function (e) {
    return e instanceof Uint8Array && (e = n(e)), i(e[0]);
  }, t.names = Object.freeze(U.names), t.codes = Object.freeze(U.codes);
}),
    D = function e(t, r, n) {
  if (Number.MAX_SAFE_INTEGER && t > Number.MAX_SAFE_INTEGER) throw e.bytes = 0, new RangeError("Could not encode varint");
  r = r || [];
  var o = n = n || 0;

  for (; t >= M;) r[n++] = 255 & t | 128, t /= 128;

  for (; -128 & t;) r[n++] = 255 & t | 128, t >>>= 7;

  return r[n] = 0 | t, e.bytes = n - o + 1, r;
},
    M = Math.pow(2, 31);

var z = function e(t, r) {
  var n,
      o = 0,
      i = 0,
      c = r = r || 0,
      a = t.length;

  do {
    if (c >= a || i > 49) throw e.bytes = 0, new RangeError("Could not decode varint");
    n = t[c++], o += i < 28 ? (127 & n) << i : (127 & n) * Math.pow(2, i), i += 7;
  } while (n >= 128);

  return e.bytes = c - r, o;
};

var C,
    N = Math.pow(2, 7),
    I = Math.pow(2, 14),
    B = Math.pow(2, 21),
    R = Math.pow(2, 28),
    P = Math.pow(2, 35),
    F = Math.pow(2, 42),
    k = Math.pow(2, 49),
    V = Math.pow(2, 56),
    _ = Math.pow(2, 63),
    L = {
  encode: D,
  decode: z,
  encodingLength: function encodingLength(e) {
    return e < N ? 1 : e < I ? 2 : e < B ? 3 : e < R ? 4 : e < P ? 5 : e < F ? 6 : e < k ? 7 : e < V ? 8 : e < _ ? 9 : 10;
  }
};

!function (e) {
  e[e.Raw = 85] = "Raw", e[e.AccessControlled = 112] = "AccessControlled";
}(C || (C = {}));

class q {
  constructor(e) {
    this.buf = e;
  }

  static fromRandom(e = q.Variant.Raw, t = 32) {
    const r = Uint8Array.from([...L.encode(q.V1), ...L.encode(e), ...a(new Uint8Array(t))]);
    return new q(r);
  }

  static fromString(e) {
    if (e.length < 2) throw new Error("id too short");
    const t = T.decode(e);
    return q.fromBytes(t);
  }

  static fromBytes(e) {
    let t = new Uint8Array(e);
    const r = L.decode(t);
    if (1 != r) throw new Error("expected 1 as the id version number, got: ".concat(r, "."));
    t = t.slice(L.decode.bytes, t.length);
    if (!(L.decode(t) in q.Variant)) throw new Error("invalid variant.");
    if (t.slice(L.decode.bytes, t.length).length < 16) throw new Error("random component too small.");
    return new q(e);
  }

  static getEncoding(e) {
    if (e.length < 2) throw new Error("Too Short");
    const t = T.isEncoded(e);
    if (!1 === t) throw new Error("Invalid Encoding");
    return t;
  }

  isDefined() {
    return this.buf.length > 0;
  }

  toBytes() {
    return this.buf;
  }

  equals(e) {
    return function (e, t) {
      if (e === t) return !0;
      if (e.byteLength !== t.byteLength) return !1;

      for (let r = 0; r < e.byteLength; r++) if (e[r] !== t[r]) return !1;

      return !0;
    }(this.buf, e.buf);
  }

  version() {
    return L.decode(this.buf);
  }

  variant() {
    let e = new Uint8Array(this.buf);
    return L.decode(e), e = e.slice(L.decode.bytes), L.decode(e);
  }

  toString(e = "base32") {
    const t = new TextDecoder();

    switch (this.version()) {
      case q.V1:
        return t.decode(T.encode(e, this.buf));

      default:
        throw new Error("unknown ID version.");
    }
  }

}

q.V1 = 1, q.Variant = C;
export default q;
export { q as ThreadID, C as Variant };